// extracted by mini-css-extract-plugin
export var container = "_f1-0";
export var icon = "_f1-1";
export var text = "_f1-2";